import { apiClient } from '@/lib/api/client';
import { refreshClientPortalFlag } from '@/lib/clientPortalFlag';

/**
 * Where a signed-in client lands. With the v2 portal on that is their event;
 * /dashboard stays routable but is only the fallback (portal off, no event, request failed).
 */
export async function resolveClientHome(): Promise<string> {
  try {
    if (!(await refreshClientPortalFlag())) return '/dashboard';
    const { data } = await apiClient.get('/events');
    const events = Array.isArray(data) ? data : (data?.events ?? data?.data ?? []);
    return events[0]?._id ? `/events/${events[0]._id}` : '/dashboard';
  } catch {
    return '/dashboard';
  }
}
